<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{$t("backends.pageTitleText")}}
            p Manage platform backend setting.
            Row(type="flex" justify="end")
                Button(:type="hasChanged?'primary':'default'" @click="updateBackendsetting" :disabled="!hasChanged") {{ $t("rcmtable.saveText") }}
        Card.a8-page-description-card(v-show="$store.state.platformPlan.multiTenancyConfigs.isSupportLicenseSystem")
            Row(type="flex" justify="space-between")
                Col(span="24")
                    List
                        ListItem
                            Col(span="6")
                                ListItemMeta(title='token' :description='$t("backends.license")')
                            Col(span="18")
                                Input(v-model="token"  @on-change="tokenChange")
        Card(v-if="isAlive")
            Tabs(v-model="currentTab" name="backEndTabs" )
                template(v-for="(tab,index) in tabItems")
                    TabPane(:label="$t('backends.'+tab.name)" :name="tab.name" tab="backEndTabs" v-if="tab.cardQuantity>0")
                        Row(type="flex" justify="space-between")
                            template(v-for="(i, k) in tab.cardQuantity" )
                                Col(span="11")
                                    Card
                                        List
                                            ListItem(v-for="(item, key) in backendsData.filter((e)=>e.type == tab.name).slice(k*10, k*10+10)" :key="item.name" )
                                                ListItemMeta(:title='$t("backendsTitle."+item.name)' :description='$t("backends."+item.name)')
                                                component(:is="item.formRender" :value="item" :option="dataOption" :title="item.name"  @changeData="addNewData")
</template>

<script>
import {
    getLicenseInfo,
    getLicenseInfoOption,
    updateLicenseInfoOption,
    getToken,
    checkToken,
    updateToken,
} from "@/api/system";
import Model from "@/components/rcmTableFormItems/Model";
import MenuModel from "@/components/rcmTableFormItems/MenuModel";
import setRoleExampleModel from "@/components/rcmTableFormItems/setRoleExampleModel";

export default {
    name: "backendsetting",
    data() {
        return {
            esIndex: "backendsetting",
            backendsData: [],
            hasChanged: false,
            newBackendsData: [],
            dataOption: {},
            content: "",
            disableReload: false,
            // cardQuantity: 0,
            token: "",
            isChangeToken: "",
            isAlive: true,
            currentTab: "system",
            tabItems: [
                {
                    name: "system",
                    cardQuantity: 0,
                },
                {
                    name: "menu-system",
                    cardQuantity: 0,
                },
            ],
        };
    },
    components: {
        Model,
        MenuModel,
        setRoleExampleModel,
    },
    computed: {},
    watch: {},
    methods: {
        async updateBackendsetting() {
            // 有更改的才動作
            if (this.newBackendsData.length > 0) {
                updateLicenseInfoOption({ license: this.newBackendsData })
                    .then((response) => {
                        if (response.data.success) {
                            this.$Notice.success({
                                title: this.$t("global.success"),
                                desc: this.$t("global.success"),
                            });
                        } else {
                            this.$Notice.warning({
                                title: this.$t("global.error"),
                                desc: `success: ${response.data.success}`,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
            }
            // 異動才更改
            if (this.isChangeToken) {
                updateToken({ token: this.token })
                    .then(async (response) => {
                        if (response.data.success) {
                            this.$Notice.success({
                                title: this.$t("global.success"),
                                desc: this.$t("global.success"),
                            });
                            this.token = response.data.token;
                        } else {
                            this.$Notice.warning({
                                title: this.$t("global.error"),
                                desc: `success: ${response.data.success}`,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
            }
            await this.reloadView();
            this.hasChanged = false;
        },
        addNewData(key, event) {
            let newObj = event;
            newObj.name = key;

            if (!this.newBackendsData.find((e) => e.name == key)) {
                this.newBackendsData.push(newObj);
            } else {
                this.newBackendsData = this.newBackendsData.map((e) => {
                    if (e.name == key) {
                        e = newObj;
                    }
                    return e;
                });
            }
            this.hasChanged = true;
        },
        async getTokenData() {
            let tokenData = await getToken();
            if (tokenData.data.success) {
                this.token = tokenData.data.token;
            }
        },
        async getData() {
            let license = await getLicenseInfo();
            if (license.data.success) {
                this.backendsData = license.data.mapData;
                this.backendsData = this.backendsData
                    .map((e) => {
                        if (e.type == "system") {
                            e.formRender = "Model";
                        } else {
                            e.formRender = "MenuModel";
                            if (e.name == "dashboardTimeRange" || e.name == "setHttpAndHttpsUseablePort") {
                                e.formRender = "Model";
                            }
                            if (e.name == "rolesManageExample") {
                                e.formRender = "setRoleExampleModel";
                            }
                        }
                        return e;
                    })
                    .filter((e) => e.isShown);
                this.tabItems = this.tabItems.map((tabItem) => {
                    tabItem.cardQuantity = Math.ceil(
                        this.backendsData.filter((item) => item.type == tabItem.name).length / 10
                    );
                    return tabItem;
                });
            }
        },
        async getDataOption() {
            await getLicenseInfoOption()
                .then((res) => {
                    if (!res.data.success) throw new Error(res.data.msg);
                    this.dataOption = res.data.mapData;
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        async tokenChange() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(async () => {
                let result = await checkToken({ token: this.token });
                if (result.data.success) {
                    this.isChangeToken = true;
                    this.hasChanged = true;
                } else {
                    this.isChangeToken = false;
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${result.data.message}`,
                    });
                }
            }, 500);
        },
        reloadView() {
            this.isAlive = false;
            var self = this;
            this.$nextTick(() => {
                setTimeout(async function () {
                    await self.getTokenData();
                    await self.getDataOption();
                    await self.getData();
                    self.isAlive = true;
                }, 1000);
            });
        },
    },
    mounted() {},
    async created() {
        await this.getTokenData();
        await this.getDataOption();
        await this.getData();
    },
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/view/system/BackEndSetting.vue